/** Toast display duration in milliseconds */
const TOAST_DURATION = 2000;

/** Toast fade out duration in milliseconds */
const FADE_OUT_DURATION = 300;

/**
 * Show a toast notification
 * @param message - Message to display
 */
export function showToast(message: string): void {
  // Remove existing toast if present
  const existing = document.querySelector('.toast');
  if (existing) {
    existing.remove();
  }

  // Create new toast
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = message;
  document.body.appendChild(toast);

  // Schedule removal
  setTimeout(() => {
    toast.style.animation = 'toastOut 0.3s ease-out forwards';
    setTimeout(() => toast.remove(), FADE_OUT_DURATION);
  }, TOAST_DURATION);
}
